import { createRouter, createWebHistory } from 'vue-router'

// Keep HomeView as eager loading for fast initial load
import HomeView from '../views/HomeView.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { 
      path: '/', 
      name: 'home', 
      component: HomeView,
      meta: {
        title: 'FireStop MX - Extintores Monterrey | Venta y Mantenimiento',
        description: 'Expertos en protección contra incendios en Monterrey. Venta, recarga y mantenimiento de extintores certificados NOM-STPS. Servicios profesionales para empresas y hogares.'
      }
    },
    { 
      path: '/servicios', 
      name: 'servicios', 
      component: () => import('../views/ServiciosView.vue'),
      meta: {
        title: 'Servicios - FireStop MX | Recarga y Mantenimiento de Extintores',
        description: 'Servicios certificados de recarga, mantenimiento e inspección de extintores. Cumplimiento NOM-154, NOM-002. Asesoría profesional en Monterrey.'
      }
    },
    { 
      path: '/contacto', 
      name: 'contacto', 
      component: () => import('../views/ContactoView.vue'),
      meta: {
        title: 'Contacto - FireStop MX | Cotización WhatsApp',
        description: 'Contáctanos para cotizaciones rápidas vía WhatsApp. Asesoría bilingüe en protección contra incendios. Soporte inmediato para empresas en Monterrey.'
      }
    },
    { 
      path: '/sala-equipos', 
      name: 'sala-equipos', 
      component: () => import('../views/SalaEquipos.vue'),
      meta: {
        title: 'Sala de Equipos - FireStop MX | Catálogo de Extintores',
        description: 'Catálogo completo de extintores certificados: PQS, CO₂, espuma, automáticos. Equipos contra incendios para empresas y hogares en Monterrey.'
      }
    },
    { 
      path: '/senalizacion', 
      name: 'senalizacion', 
      component: () => import('../views/SenalizacionView.vue'),
      meta: {
        title: 'Señalamientos de Seguridad Industrial - FireStop MX',
        description: 'Guía profesional de señalización obligatoria, recomendada y opcional para seguridad industrial en México. Cumple con NOM-002-STPS-2010.'
      }
    },
  ]
})

// Navigation guard to update page title and meta description
router.beforeEach((to) => {
  // Update document title
  if (to.meta?.title) {
    document.title = to.meta.title as string
  }
  
  // Update meta description
  const descriptionMeta = document.querySelector('meta[name="description"]')
  if (to.meta?.description && descriptionMeta) {
    descriptionMeta.setAttribute('content', to.meta.description as string)
  }
})

export default router
